import Routes from "./routes";
import { useMutation } from "@tanstack/react-query";
import apiClient from "@apis/index";

export const useCreateContract = () => {
  return useMutation({
    mutationFn: (data: { plan_type: string; pricings: any }) =>
      apiClient.post(Routes.CREATE_CONTRACT, data),
  });
};

export const useUpdateContract = () => {
  return useMutation({
    mutationFn: (data: { plan_type: string; pricings: any[] }) =>
      apiClient.put(Routes.UPDATE_CONTRACT, data),
  });
};

export const useValidateCoupon = () => {
  return useMutation({
    mutationFn: (data: { coupon_code: string; product_id: string[] }) =>
      apiClient.post(Routes.VALIDATE_COUPON, data),
  });
};
